import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Handler interface for showing authentication dialog when session expires
 */
export interface AuthDialogHandler {
  /**
   * Opens authentication dialog and returns observable that emits when complete
   * @param options - Dialog options
   * @returns Observable that emits true if user authenticated, false if cancelled
   */
  showAuthDialog(options?: {
    allowClose?: boolean;
    initialMode?: 'social' | 'login' | 'register' | 'forgot-password';
    message?: string;
  }): Observable<boolean>;
}

/**
 * Injection token for auth dialog handler
 * This allows the interceptor to open auth dialogs without circular dependencies
 */
export const AUTH_DIALOG_HANDLER = new InjectionToken<AuthDialogHandler>(
  'AUTH_DIALOG_HANDLER',
);
